<template>
  <div
    v-click-outside="closeMenu"
    class="menu-profile"
  >
    <div
      class="menu-profile__container"
      @click="handleClickProfile"
    >
      <div
        class="menu-profile_thumbnail"
        :style="profileImageStyle"
      />
      <div class="menu-profile_center-name responsive-visible desktop">
        {{ centerName }}
      </div>
      <i class="el-icon-arrow-down responsive-visible desktop" />
    </div>

    <transition
      name="el-zoom-in-top"
    >
      <div
        v-show="isMenuVisible"
        class="menu-profile_sub-menu top-menu__popup"
      >
        <ul>
          <li
            v-if="isOwnerAccount"
            v-show="!isDemoCenter"
          >
            <router-link
              to="/account"
              @click.native="closeMenu"
            >
              계정 관리
            </router-link>
          </li>
          <li v-if="isOwnerAccount">
            <router-link
              to="/payment"
              @click.native="closeMenu"
            >
              결제 정보
            </router-link>
          </li>
          <li
            v-if="isOwnerAccount"
            v-show="!isDemoCenter"
          >
            <router-link
              to="/referral"
              @click.native="closeMenu"
            >
              지인 초대 & 혜택
            </router-link>
          </li>
          <hr v-if="isOwnerAccount">
          <li>
            <router-link
              to="/fiflbox-notices"
              @click.native="closeMenu"
            >
              공지사항
            </router-link>
          </li>
          <li
            v-show="!isDemoCenter"
            id="one-to-one-inquiry"
            @click="closeMenu"
          >
            1:1 문의
          </li>
          <li>
            <a
              href="#"
              @click="closeMenuWithOpenPage"
            >
              FAQ
            </a>
          </li>
          <hr>
          <li @click="handleClickLogout">
            로그아웃
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import { fiflboxApi } from '@/utils/api';
import { computedGetters } from '@/utils/vuex-helper';

export default {
  name: 'MenuProfile',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    profileImageSrc: {
      type: String,
      default: null,
    },
    centerName: {
      type: String,
      default: '',
    },
    isDemoCenter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMenuVisible: false,
    };
  },
  computed: {
    ...computedGetters([
      'role',
      'isOwnerAccount',
    ]),
    profileImageStyle() {
      if (this.profileImageSrc === null) {
        return {};
      }

      return {
        backgroundImage: `url(${this.profileImageSrc})`,
      };
    },
  },
  methods: {
    handleClickProfile() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    closeMenu() {
      this.isMenuVisible = false;
    },
    closeMenuWithOpenPage(event){
      event.preventDefault();
      this.isMenuVisible = false;
      window.open('https://intercom.help/fiflbox/ko/','_blank');
    },
    async handleClickLogout() {
      try {
        await fiflboxApi.v1.postAccountsLogout();
      } catch (err) {
        console.log(err);
      }
      await this.$store.dispatch('timeTable/resetTimeTableInfos');
      await this.$tokenStorage.deleteToken();
      location.replace('');
    },
  },
};
</script>

<style lang="scss">
.top-menu__popup {
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(180, 180, 180, 0.5);
	border: solid 1px #d3d3d3;
	background-color: #ffffff;

	hr {
		border: solid 1px #f2f2f2;
		margin: 10px 0;
	}
}

.menu-profile {
	position: relative;
	height: 100%;
	cursor: pointer;

	.menu-profile__container {
		height: 100%;
		align-items: center;
		display: flex;

		.menu-profile_thumbnail {
			background-color: #f2f2f2;
			width: 40px;
			height: 40px;
			border-radius: 40px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			margin-right: 2px;
			display: inline-block;
		}

		.menu-profile_center-name {
			width: 100px;
			font-size: 13px;
			letter-spacing: -0.7px;
			text-align: center;
			color: #4a4a4a;
			line-height: 40px;

			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			margin-right: 10px;
		}

		.el-icon-arrow-down {
			line-height: 40px;
			color: #b9b9b9;
			font-size: 13px;
		}
	}

	.menu-profile_sub-menu {
		z-index: 99999;
		display: block;
		position: absolute;
		top: 60px;
		right: 0;
		width: 116px;
		padding: 10px 0;

		ul {
			display: block;
			list-style-type: none;
			margin: 0;
			padding: 0;
		}

		li {
			font-size: 14px;
			line-height: 30px;
			height: 30px;
			letter-spacing: -0.8px;
			color: #4a4a4a;
			padding: 0 12px;

			a {
				color: #4a4a4a;
				text-decoration: none;
				width: 100%;
				display: inline-block;
			}

			&:hover {
				background-color: #f9f9f9;
				cursor: pointer;
			}
		}
	}
}
</style>
